import { render, staticRenderFns } from "./WhatToDoWhen.vue?vue&type=template&id=328448b8&"
import script from "./WhatToDoWhen.vue?vue&type=script&lang=js&"
export * from "./WhatToDoWhen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports